import React from 'react';
import { Card, CardContent, Box, Typography, TextField, InputAdornment, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Skeleton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function DashboardRecentActivities({
  title = 'Recent Activities',
  list,
  pagination,
  loading,
  searchInput,
  onSearchInputChange,
  onSearchKeyPress,
  onSearchKeyDown,
  onClearSearch,
  onPageChange,
  onRowsPerPageChange,
  onViewLog,
  rowsPerPageOptions = [5, 10, 25, 50],
}) {
  const handleKeyDown = (e) => {
    if (onSearchKeyDown) onSearchKeyDown(e);
    else if (onSearchKeyPress) onSearchKeyPress(e);
  };
  const totalCount = pagination?.total ?? 0;
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>{title}</Typography>
          {!loading && (
            <TextField
              placeholder="Search activities..."
              value={searchInput}
              onChange={(e) => onSearchInputChange(e.target.value)}
              onKeyDown={handleKeyDown}
              size="small"
              sx={{ width: { xs: '100%', sm: 300 }, maxWidth: '100%' }}
              InputProps={{
                startAdornment: <InputAdornment position="start"><SearchIcon color="action" /></InputAdornment>,
                endAdornment: searchInput && <InputAdornment position="end"><IconButton size="small" onClick={onClearSearch} edge="end"><ClearIcon /></IconButton></InputAdornment>,
              }}
            />
          )}
        </Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Log Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>Time Ago</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody>
                {[...Array(pagination?.pageSize || 5)].map((_, i) => (
                  <TableRow key={i}><TableCell colSpan={5}><Skeleton animation="wave" height={40} /></TableCell></TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                {list?.length > 0 ? list.map((activity, index) => (
                  <TableRow key={activity.id || index}>
                    <TableCell>{activity.log_name}</TableCell>
                    <TableCell>{activity.description}</TableCell>
                    <TableCell>{activity?.causer?.name || 'N/A'}</TableCell>
                    <TableCell>{activity.time_ago}</TableCell>
                    <TableCell>
                      <IconButton size="small" onClick={() => onViewLog(activity?.id)}><VisibilityIcon /></IconButton>
                    </TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={5} sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        No recent activities
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        {!loading && totalCount > 0 && (
          <TablePagination
            component="div"
            count={totalCount}
            page={(pagination?.page || 1) - 1}
            onPageChange={(_, newPage) => onPageChange(newPage + 1)}
            rowsPerPage={pagination?.pageSize || rowsPerPageOptions[0] || 10}
            onRowsPerPageChange={(e) => onRowsPerPageChange(Number(e.target.value))}
            rowsPerPageOptions={rowsPerPageOptions}
            labelRowsPerPage="Rows per page"
          />
        )}
      </CardContent>
    </Card>
  );
}
